import "./Colors.css";

export default function Colors() {
  return (
    <section className="ui-kit-section">
      <h2 className="ui-kit-title">Colors</h2>

      <div className="ui-colors">
        {/* LEFT COLUMN */}
        <div className="ui-colors__column">
          <ColorItem label="Header" colorVar="--color-header" />
          <ColorItem label="Button" colorVar="--color-button" />
          <ColorItem label="Bottom menu" colorVar="--color-bottom-menu" />
          <ColorItem label="Main button" colorVar="--color-main-button" />
          <ColorItem label="Text for main button" colorVar="--color-main-button-text" />
          <ColorItem label="Bag full" colorVar="--color-bag-full" />
          <ColorItem label="Text for bag full" colorVar="--color-bag-full-text" />
          <ColorItem label="List button" colorVar="--color-list-button" />
          <ColorItem label="Badge bg for list button" colorVar="--color-list-badge" />
          <ColorItem label="Input bg" colorVar="--color-input-bg" />
        </div>

        {/* RIGHT COLUMN */}
        <div className="ui-colors__column">
          <ColorItem label="Text" colorVar="--color-text" />
          <ColorItem label="Subtext 1" colorVar="--color-subtext-1" />
          <ColorItem label="Subtext 2" colorVar="--color-subtext-2" />
          <ColorItem label="Subtext 3" colorVar="--color-subtext-3" />
          <ColorItem label="Subtext 4" colorVar="--color-subtext-4" />
          <ColorItem label="Bg 1" colorVar="--color-bg-1" />
          <ColorItem label="Bg 2" colorVar="--color-bg-2" />
          <ColorItem label="Bg 3" colorVar="--color-bg-3" />
          <ColorItem label="Error" colorVar="--color-error" />
          <ColorItem label="Error bg" colorVar="--color-error-bg" />
          <ColorItem label="Success" colorVar="--color-success" />
        </div>
      </div>
    </section>
  );
}

function ColorItem({ label, colorVar }) {
  return (
    <div className="ui-color-item">
      <div
        className="ui-color-item__square"
        style={{ "--preview-color": `var(${colorVar})` }}
        aria-label={label}
        title={`${label} (${colorVar})`}
      />
      <span className="ui-color-item__label">
        {label}
        <span className="ui-color-item__token">{colorVar}</span>
      </span>
    </div>
  );
}
